import React from "react";
import { IHistoryProps } from "./HistoryProps";
import {
  StyledContainer,
  StyledSubTitle,
  HistoryTitle,
  Description,
  HistoryCarouselFull,
  HistoryCarouselMobile,
  ImageContainer,
} from "./HistoryHelpers";
import { Container, Row, Col } from "react-bootstrap";
import { slugify } from "transliteration";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

const History: React.FC<IHistoryProps> = (props) => {
  const { isMobileOnly } = useMobileDetectContext();
  return (
    <StyledContainer>
      <Container fluid="sm">
        <Row>
          <ImageContainer
            image={props.relationships.media.relationships.image}
            title={props.field_title}
          />
        </Row>
        <Row className="text-container">
          <Col className="descriptionCol">
            <StyledSubTitle id={slugify(props.field_subtitle)}>
              {props.field_subtitle}
            </StyledSubTitle>
            <HistoryTitle id={slugify(props.field_title)}>
              {props.field_title}
            </HistoryTitle>
            <Description id={"history-description"}>
              {props.field_description}
            </Description>
          </Col>
          <Col>
            {isMobileOnly ? (
              <HistoryCarouselMobile {...props} />
            ) : (
              <HistoryCarouselFull {...props} />
            )}
          </Col>
        </Row>
      </Container>
    </StyledContainer>
  );
};

export default History;
